<template>
  <div class="formily-todo" :class="{ 'enable-width-setting': enableWidthSetting }">
    <FormProvider :form="form" v-loading.lock.fullscreen="form.loading">
      <FormLayout :labelCol="0" :wrapperCol="0" :labelWidth="120">
        <SchemaField :schema="formSchema || {}" />
      </FormLayout>
    </FormProvider>
  </div>
</template>

<script>
import { createForm } from "@formily/core";
import Space from "./Space";
import Input from "./Input";
import Upload from "./Upload";
import Picker from "./Picker";
import TimePicker from "./TimePicker";
import Quill from "@/components/Formily/quill";
import Text from "./text";
import HtmlText from "./htmlText.ts";
import Link from "./link";
import Images from "./images.ts";
import Button from "./button";
import FormTab from "./formTab";
import Scanner from "./scanner.js";
import MoveTabNavigation from "./MoveTabNavigation-new.vue";

import Export from "./Export.vue";
import Import from "./import.ts";
import Location from "./location.ts";
import Contact from "./contact.ts";
import FormCollapse from "./FormCollapse.js";
import Signature from "./signature.ts";
import ArrayCards from "./card.js";
import BackTop from "./backTop.js";
import TimeButton from "./timeButton.ts";
import NewCheckbox from "./newCheckbox.ts";
import NewUpload from "./newUpload.js";
import EmailSelect from "./emailSelect.ts";
import ToStorageTable from "@/components/Formily/toStorageTable.ts";
import OutboundMeasurementTable from "@/components/Formily/OutboundMeasurementTable.ts";
import OutgoingPieceworkTable from "@/components/Formily/OutgoingPieceworkTable.ts";
import undercarriageGoBackTable from "@/components/Formily/undercarriageGoBackTable.ts";
import Template from "@/components/Formily/FormilyTemplate-new.vue";
import { isEqual } from "lodash";
import flowTable from "@/views/todo-details-paeg/assetFlow/flowTable.ts";
import {
  formilyStepper,
  formilyCascader,
  formilyTimePicker,
  formilyFormItem,
  formilySwitch,
  formilyFormGrid,
} from "./index.ts";
import CommonSelect from "@/components/Formily/CommonSelect";
import UserSelect from "@/components/Formily/userSelect";
import VoiceAssistant from "@/components/VoiceAssistant/index.vue";
import { FormProvider, createSchemaField } from "@formily/vue";
import ServerEntryTable from "@/components/Formily/ServerEntryTable.ts";
import ServerOutboundTable from "@/components/Formily/ServerOutboundTable.ts";
import FacilityAssetEntryTable from "@/components/Formily/FacilityAssetEntryTable.ts";
import FacilityAssetReleaseTable from "@/components/Formily/FacilityAssetReleaseTable.ts";
import Steps from "./steps.ts";
import networkOutboundTable from "@/components/Formily/networkOutboundTable.ts";
import assetLocationVerificationTable from "@/components/Formily/assetLocationVerificationTable.ts";
import serverDirectAllocationTable from "@/components/Formily/serverDirectAllocationTable.ts";
import acceptanceTable from "@/views/operateData/flowfile/acceptanceTable.ts";
import AssetesCascader from "@/components/Formily/assetesCascader.ts";
import idcdbPaginatedTable from "@/views/todo-details-paeg/equipmentManagement/components/idcdbPaginatedTable.vue";
import PlanTable from "@/components/Formily/planTable.ts";
import RecordingButton from "@/components/Formily/recordingButton.ts";
import maintainDetails from "@/views/maintainDetails/index.vue";
import connectWith from "@/views/connectWith/index.vue";
import managerCheck from "@/views/connectWith/managerCheck/index.vue";
import HotTable from "@/components/Formily/HotTable.ts";
import fireFacilityCheck from "@/views/connectWith/fireFacilityCheck/index.vue";

import {
  Form,
  Group,
  Submit,
  // ArrayTable,
  // Input,
  // Editable,
  PreviewText,
  Checkbox,
  // FormGrid,
  // Select,
  // Picker,
  // ArrayItems,
  // Space,
  FormLayout,
  // Reset,
  // Cascader,
  // Password,
  // TimePicker,
  // DatetimePicker,
} from "@formily/vant";
import Radio from "./Radio.js";
import { ArrayTable } from "@formily/element";
// import Breadcrumb from '@/components/Breadcrumb';
import { Message, Dialog, MessageBox } from "element-ui";
import { getDataByNbrokerUrl } from "@/api/tickets/ticketsApi.js";
import dayjs from "dayjs";
import store from "@/store";
import NewArrayTable from "./newArrayTable";

import NewArrayCards from "./newcard";

import MobileArrayCards from "./mobilecard.js";
import CountDownTimeButton from "./CountDownTimeButton.ts";

/**
 * 计算 enableWidthSetting 配置
 * 从七彩石配置中读取 enable_card_refresh_key，决定是否启用宽度设置
 * @returns {boolean} 是否启用宽度设置
 */
function calculateEnableWidthSetting() {
  let enableWidthSetting = false;
  try {
    if (store?.getters?.getConfigItem) {
      // 获取配置并解析为 JSON 格式
      const configStr = store.getters.getConfigItem("enable_card_refresh_key");
      //       const configStr = `{
      //   "open":false,
      //   "key":["Vxiangloli-Test-AiDesigner","wb_sub_ticket","Infrastructure_Maintenance_Main_Process_Rental","Infrastructure_Maintenance_Main_Process_self-establish","maintenace_problem_solve_ticket_3.0","maintenance_overseer_record"]
      // }`;

      if (configStr) {
        try {
          const config = JSON.parse(configStr);

          // 如果 open 为 false，则功能关闭
          if (config.open === false) {
            enableWidthSetting = false;
          } else if (config.open === true) {
            // 如果 open 为 true，检查 key 数组
            const keyArray = Array.isArray(config.key) ? config.key : [];

            if (keyArray.length === 0) {
              // key 数组为空，对所有流程生效
              enableWidthSetting = true;
            } else {
              // key 数组不为空，只对相应流程生效
              const currentProcessKey = store.state.config?.ProcessDefinitionKey || "";

              if (currentProcessKey && keyArray.includes(currentProcessKey)) {
                enableWidthSetting = true;
              } else {
                enableWidthSetting = false;
              }
            }
          }
        } catch (parseError) {
          // JSON 解析失败，降级为旧的布尔值逻辑
          console.warn(
            "[formilyTodoForm-new] 配置解析失败，降级为布尔值判断",
            parseError
          );
          enableWidthSetting = false;
        }
      }
    }
  } catch (e) {
    // 配置读取失败，默认关闭
    console.warn("[formilyTodoForm-new] 读取七彩石配置失败", e);
  }
  return enableWidthSetting;
}

const fields = createSchemaField({
  components: {
    Form,
    Submit,
    FormItem: formilyFormItem,
    ArrayTable,
    ArrayCards,
    NewArrayTable,
    NewArrayCards,
    MobileArrayCards,
    Input,
    // Editable,
    PreviewText,
    Checkbox,
    FormGrid: formilyFormGrid,
    Select: Picker,
    // ArrayItems,
    Space,
    FormLayout,
    // Reset,
    // Text,
    // Link,
    // Button,
    Radio,
    // Password,
    TimePicker,
    DatePicker: formilyTimePicker,
    TextArea: Input,
    Switch: formilySwitch,
    Password: Input,
    FormCollapse,
    Location,
    // FormTab,
    // ArrayCards,
    Template,
    Upload,
    Cascader: formilyCascader,
    Quill,
    Text,
    Link,
    FormTab,
    Button,
    NumberPicker: formilyStepper,
    UserSelect,
    CommonSelect,
    Images,
    Scanner,
    MoveTabNavigation,
    Signature,
    Export,
    Import,
    Contact,
    BackTop,
    TimeButton,
    NewCheckbox,
    NewUpload,
    ToStorageTable,
    OutboundMeasurementTable,
    OutgoingPieceworkTable,
    undercarriageGoBackTable,
    // ArrayCollapse,
    // Quill,
    // UserSelect,
    // CommonSelect,
    HtmlText,
    ServerEntryTable,
    ServerOutboundTable,
    flowTable,
    FacilityAssetReleaseTable,
    FacilityAssetEntryTable,
    Steps,
    assetLocationVerificationTable,
    serverDirectAllocationTable,
    acceptanceTable,
    networkOutboundTable,
    AssetesCascader,
    idcdbPaginatedTable,
    VoiceButton: VoiceAssistant,
    CountDownTimeButton,
    PlanTable,
    EmailSelect,
    RecordingButton,
    maintainDetails,
    connectWith,
    managerCheck,
    HotTable,
    fireFacilityCheck,
  },
  scope: {
    ding: document.querySelector("#ding-mp3"),
    alarm: document.querySelector("#alarm-mp3"),
    finish: document.querySelector("#finish-mp3"),
    currentUser: sessionStorage.getItem("userid") || "",
    Message,
    Dialog,
    MessageBox,
    getDataByNbrokerUrl,
    dayjs,
    rainbowData: store.state.config,
  },
});

export default {
  components: { FormLayout, FormProvider, ...fields },
  props: ["schema", "values", "disabled"],
  data() {
    const form = createForm();
    const formSchema = this.formatSchema(this.schema);
    // const formCollapse = FormCollapse.createFormCollapse()
    return {
      // qqq,
      form,
      formSchema,
      // formCollapse,
      enableWidthSetting: false,
    };
  },
  watch: {
    schema(newVal) {
      this.formSchema = this.formatSchema(newVal);
    },
    values: {
      handler(newVal, oldVal) {
        if (isEqual(newVal, oldVal)) return;
        const val = this.formatValue(newVal);
        this.form.setValues(val, "deepMerge");
      },
      deep: true,
    },
  },
  created() {
    // 计算 enableWidthSetting 的值
    this.enableWidthSetting = this.getEnableWidthSetting();

    // 监听 Radio 字段的 enum 变化，兼容 { label, value } 格式
    // 仅当 enableWidthSetting 为 true 时才启用
    if (this.enableWidthSetting) {
      this.form.subscribe(({ payload }) => {
        const field = payload;
        if (
          (field?.component?.[0] === "Radio" ||
            field?.component?.[0] === "Radio.Group") &&
          Array.isArray(field.dataSource)
        ) {
          field.dataSource = field.dataSource.map((item) =>
            typeof item === "object" &&
            item.value !== undefined &&
            item.name === undefined
              ? { ...item, name: item.value }
              : item
          );
        }
      });
    }

    // 为数组容器（ArrayTable / MobileArrayCards）内部的字段添加标记，统一在此处维护
    // this.addFlagToArrayContainerSchema(); // 已废弃，改用 DOM 查找方式
  },
  mounted() {
    const val = this.formatValue(this.values);
    this.form.setValues(val);
  },
  updated() {
    // 🎨 DOM 更新后重新注入 titleColor 样式，确保表头颜色生效
    this.$nextTick(() => {
      this.injectTitleColorStyles();
    });
  },
  methods: {
    /**
     * 获取 enableWidthSetting 配置
     * 从七彩石配置中读取 enable_card_refresh_key，决定是否启用宽度设置
     * @returns {boolean} 是否启用宽度设置
     */
    getEnableWidthSetting() {
      return calculateEnableWidthSetting();
    },

    /**
     * 将自增表格转换为自增卡片的工具函数
     * @param {Object} schema - 包含自增表格的 schema 对象
     * @returns {Object} 转换后的包含自增卡片的 schema 对象
     */
    convertArrayTableToArrayCards(schema) {
      if (!schema || !schema.properties || !store.getters.getConfigItem("convertCard")) {
        return schema;
      }

      const convertedSchema = JSON.parse(JSON.stringify(schema)); // 深拷贝

      // 递归遍历所有属性
      this._recursiveConvertArrayTable(convertedSchema.properties);

      return convertedSchema;
    },

    /**
     * 递归转换 ArrayTable 为 ArrayCards
     * @param {Object} properties - schema 的 properties 对象
     */
    _recursiveConvertArrayTable(properties) {
      if (!properties) return;

      Object.keys(properties).forEach((key) => {
        const property = properties[key];

        // 检查是否是 ArrayTable 组件
        if (
          property["x-component"] === "ArrayTable" &&
          property?.["x-component-props"]?.convert
        ) {
          // console.log('property', property);

          this._convertSingleArrayTable(property);
        }
        // 检查是否是 NewArrayTable 组件
        if (
          property["x-component"] === "NewArrayTable" &&
          property?.["x-component-props"]?.convert
        ) {
          this._convertSingleArrayTable(property);
        }

        // 递归处理嵌套的 properties
        if (property.properties) {
          this._recursiveConvertArrayTable(property.properties);
        }

        // 递归处理 items 中的 properties
        if (property.items && property.items.properties) {
          this._recursiveConvertArrayTable(property.items.properties);
        }
      });
    },

    /**
     * 转换单个 ArrayTable 为 ArrayCards
     * @param {Object} arrayTableProperty - ArrayTable 属性对象
     */
    _convertSingleArrayTable(arrayTableProperty) {
      // 兜底：参数校验
      if (!arrayTableProperty || typeof arrayTableProperty !== "object") {
        // console.warn('[ArrayCards] _convertSingleArrayTable: arrayTableProperty 无效', arrayTableProperty);
        return;
      }

      // 兜底：没有 items 则无需转换，直接改组件类型即可
      if (!arrayTableProperty.items || !arrayTableProperty.items.properties) {
        arrayTableProperty["x-component"] = "MobileArrayCards";
        return;
      }

      // 用于给卡片字段分配唯一递增的 x-index，避免 getOrderProperties 中互相覆盖
      let fieldOrderIndex = 1;

      // 更改组件类型
      arrayTableProperty["x-component"] = "MobileArrayCards";

      // 转换组件属性
      if (arrayTableProperty["x-component-props"]) {
        const oldProps = arrayTableProperty["x-component-props"];
        // console.log('oldProps==>',oldProps);

        arrayTableProperty["x-component-props"] = {
          // title: oldProps.title || 'Title',
          title: oldProps.title || null,

          titleDesc: oldProps.titleDesc || "",
          convertCollapseBtn:oldProps.convertCollapseBtn ,
          allCollapseBtn: oldProps.allCollapseBtn,
          defaultAllCollapsed: oldProps.defaultAllCollapsed,
          HorizontalVersion:
            oldProps.HorizontalVersion !== undefined ? oldProps.HorizontalVersion : true,
          // 移除分页配置，ArrayCards 不需要分页
        };
        // console.log('props==>', arrayTableProperty['x-component-props']);
      } else {
        arrayTableProperty["x-component-props"] = {
          // title: 'Title',
          title: null,

          titleDesc: oldProps.titleDesc || "",
        };
      }

      // 转换 items 结构
      if (arrayTableProperty.items && arrayTableProperty.items.properties) {
        const tableColumns = arrayTableProperty.items.properties;
        const cardProperties = {};
        const cardActions = {};

        // 按照原始x-index顺序排序列，保持ArrayTable.Column的原始顺序
        const sortedColumnKeys = Object.keys(tableColumns).sort((a, b) => {
          const indexA = tableColumns[a]["x-index"] || 0;
          const indexB = tableColumns[b]["x-index"] || 0;
          return indexA - indexB;
        });

        // 提取表格列并转换为卡片字段，保持原始顺序
        sortedColumnKeys.forEach((columnKey) => {
          const column = tableColumns[columnKey];

          if (
            column["x-component"] === "ArrayTable.Column" ||
            column["x-component"] === "NewArrayTable.Column"
          ) {
            // 检查列中是否包含需要跳过的组件
            let shouldSkipColumn = false;
            let hasActionComponents = false;

            if (column.properties) {
              Object.values(column.properties).forEach((field) => {
                // 检查是否包含ArrayTable.Index组件
                if (
                  field["x-component"] === "ArrayTable.Index" ||
                  field["x-component"] === "NewArrayTable.Index"
                ) {
                  shouldSkipColumn = true;
                }
                // 检查是否包含操作按钮组件
                if (
                  [
                    "ArrayTable.Remove",
                    "ArrayTable.MoveUp",
                    "ArrayTable.MoveDown",
                    "NewArrayTable.Remove",
                    "NewArrayTable.MoveUp",
                    "NewArrayTable.MoveDown",
                  ].includes(field["x-component"])
                ) {
                  hasActionComponents = true;
                  shouldSkipColumn = true;
                }
              });

              // 如果包含操作按钮，处理这些按钮但跳过列本身
              if (hasActionComponents) {
                Object.keys(column.properties).forEach((actionKey) => {
                  const action = column.properties[actionKey];
                  if (
                    action["x-component"] === "ArrayTable.Remove" ||
                    action["x-component"] === "NewArrayTable.Remove"
                  ) {
                    cardActions[`remove_${actionKey}`] = {
                      ...action,
                      type: "void",
                      "x-component": "MobileArrayCards.Remove",
                      "x-designable-id":
                        action["x-designable-id"] || `remove_${Date.now()}`,
                      "x-designable-source-name":
                        action["x-designable-source-name"] || "MobileArrayCards.Remove",
                      "x-index": 900 + Object.keys(cardActions).length,
                    };
                  } else if (
                    action["x-component"] === "ArrayTable.MoveUp" ||
                    action["x-component"] === "NewArrayTable.MoveUp"
                  ) {
                    cardActions[`moveUp_${actionKey}`] = {
                      ...action,
                      type: "void",
                      "x-component": "MobileArrayCards.MoveUp",
                      "x-designable-id":
                        action["x-designable-id"] || `moveUp_${Date.now()}`,
                      "x-designable-source-name":
                        action["x-designable-source-name"] || "MobileArrayCards.MoveUp",
                      "x-index": 900 + Object.keys(cardActions).length,
                    };
                  } else if (
                    action["x-component"] === "ArrayTable.MoveDown" ||
                    action["x-component"] === "NewArrayTable.MoveDown"
                  ) {
                    cardActions[`moveDown_${actionKey}`] = {
                      ...action,
                      type: "void",
                      "x-component": "MobileArrayCards.MoveDown",
                      "x-designable-id":
                        action["x-designable-id"] || `moveDown_${Date.now()}`,
                      "x-designable-source-name":
                        action["x-designable-source-name"] || "MobileArrayCards.MoveDown",
                      "x-index": 900 + Object.keys(cardActions).length,
                    };
                  }
                });
              }
            }

            // 如果包含需要跳过的组件，跳过这个列
            if (shouldSkipColumn) {
              return;
            }

            // 获取列的标题
            // const columnTitle = column['x-component-props']?.title || 'Title';
            const columnTitle = column["x-component-props"]?.title || null;

            // console.log('columnTitle==>', columnTitle);

            // 处理普通列
            if (column.properties) {
              // 按字段自身的 x-index 排序后再分配新的连续 x-index。
              // 不能直接用 Object.keys 的插入顺序：该顺序取决于 schema 的序列化来源，
              // 设计器保存、后端 map 序列化等环节都可能把键排成字母序，
              // 导致卡片字段顺序与 PC 端表格列顺序不一致（表现为移动端乱序）。
              const sortedFieldKeys = Object.keys(column.properties).sort((a, b) => {
                const fa = Number(column.properties[a]["x-index"]);
                const fb = Number(column.properties[b]["x-index"]);
                const na = Number.isNaN(fa);
                const nb = Number.isNaN(fb);
                // 两者都有 x-index：按 x-index 升序
                if (!na && !nb) return fa - fb;
                // 有 x-index 的排在前面，无 x-index 的保持原有相对顺序兜底
                if (na && !nb) return 1;
                if (!na && nb) return -1;
                return 0;
              });

              sortedFieldKeys.forEach((fieldKey) => {
                const field = column.properties[fieldKey];

                // 将字段添加到卡片属性中，并设置正确的title
                cardProperties[fieldKey] = {
                  ...field,
                  // 如果字段本身没有title，使用列的title
                  title: field.title || columnTitle,
                  "x-decorator": [
                    "DatePicker",
                    "Select",
                    "TimePicker",
                    "Input",
                    "Input.TextArea",
                    "Cascader",
                    "Space",
                    "FormGrid",
                  ].includes(field["x-component"])
                    ? null
                    : "FormItem",
                  // 分配唯一递增的 x-index，避免 getOrderProperties 中互相覆盖
                  "x-index": fieldOrderIndex++,
                };
              });
            }
          } else if (
            column["x-component"] &&
            (column["x-component"].startsWith("ArrayTable.") ||
              column["x-component"].startsWith("NewArrayTable."))
          ) {
            // 处理操作列中的按钮
            if (column.properties) {
              Object.keys(column.properties).forEach((actionKey) => {
                const action = column.properties[actionKey];
                if (
                  action["x-component"] === "ArrayTable.Remove" ||
                  action["x-component"] === "NewArrayTable.Remove"
                ) {
                  cardActions[`remove_${actionKey}`] = {
                    ...action,
                    type: "void",
                    "x-component": "MobileArrayCards.Remove",
                    "x-designable-id":
                      action["x-designable-id"] || `remove_${Date.now()}`,
                    "x-designable-source-name":
                      action["x-designable-source-name"] || "MobileArrayCards.Remove",
                    "x-index": 900 + Object.keys(cardActions).length,
                  };
                } else if (
                  action["x-component"] === "ArrayTable.MoveUp" ||
                  action["x-component"] === "NewArrayTable.MoveUp"
                ) {
                  cardActions[`moveUp_${actionKey}`] = {
                    ...action,
                    type: "void",
                    "x-component": "MobileArrayCards.MoveUp",
                    "x-designable-id":
                      action["x-designable-id"] || `moveUp_${Date.now()}`,
                    "x-designable-source-name":
                      action["x-designable-source-name"] || "MobileArrayCards.MoveUp",
                    "x-index": 900 + Object.keys(cardActions).length,
                  };
                } else if (
                  action["x-component"] === "ArrayTable.MoveDown" ||
                  action["x-component"] === "NewArrayTable.MoveDown"
                ) {
                  cardActions[`moveDown_${actionKey}`] = {
                    ...action,
                    type: "void",
                    "x-component": "MobileArrayCards.MoveDown",
                    "x-designable-id":
                      action["x-designable-id"] || `moveDown_${Date.now()}`,
                    "x-designable-source-name":
                      action["x-designable-source-name"] || "MobileArrayCards.MoveDown",
                    "x-index": 900 + Object.keys(cardActions).length,
                  };
                }
              });
            }
          }
        });

        // 重构 items 结构为 ArrayCards 格式
        arrayTableProperty.items = {
          type: "object",
          "x-designable-id":
            arrayTableProperty.items["x-designable-id"] || `card_item_${Date.now()}`,
          "x-designable-source-name":
            arrayTableProperty.items["x-designable-source-name"] || "card_item",
          properties: {
            // 添加索引组件
            index: {
              type: "void",
              "x-component": "MobileArrayCards.Index",
              "x-designable-id": `index_${Date.now()}`,
              "x-designable-source-name": "MobileArrayCards.Index",
              "x-index": 0,
            },
            // 平铺所有卡片字段（直接展开，不再包 fields 容器）
            ...cardProperties,
            // 添加操作按钮
            ...cardActions,
          },
        };

        // 处理 Addition 按钮
        if (arrayTableProperty.properties) {
          Object.keys(arrayTableProperty.properties).forEach((propKey) => {
            const prop = arrayTableProperty.properties[propKey];

            if (
              prop["x-component"] === "ArrayTable.Addition" ||
              prop["x-component"] === "NewArrayTable.Addition"
            ) {
              prop["x-component"] = "MobileArrayCards.Addition";
            }
          });
        }
      }
    },

    /**
     * 批量转换 schema 中的所有 ArrayTable 为 ArrayCards
     * @param {Object} formSchema - 完整的表单 schema
     * @returns {Object} 转换后的 schema
     */
    batchConvertArrayTables(formSchema) {
      if (!formSchema) return formSchema;

      return this.convertArrayTableToArrayCards(formSchema);
    },

    /**
     * 应用转换后的 schema 到当前表单
     * @param {Object} newSchema - 新的 schema 对象
     */
    applyConvertedSchema(newSchema) {
      this.formSchema = this.formatSchema(newSchema);
      this.$forceUpdate();
    },

    /**
     * 获取转换后的 schema（不改变当前表单）
     * @returns {Object} 转换后的 schema
     */
    getConvertedSchema() {
      return this.convertArrayTableToArrayCards(this.schema);
    },

    /**
     * 直接转换当前表单的 ArrayTable 为 ArrayCards
     */
    convertCurrentFormArrayTables() {
      const convertedSchema = this.convertArrayTableToArrayCards(this.schema);
      this.applyConvertedSchema(convertedSchema);
      return convertedSchema;
    },
    formatValue(val) {
      const res = JSON.stringify(val, (key, value) => {
        if (Array.isArray(value)) {
          return value.map((item) => (item === null ? {} : item));
        }
        return value;
      });
      return JSON.parse(res);
    },
    recursiveDelete(obj, enableWidthSettingCache) {
      if (!obj) return;

      // 🎨 初始化 titleColor 计数器和映射表
      if (!this._testColorCounter) this._testColorCounter = 0;
      if (!this._titleColorMap) this._titleColorMap = {};

      // 使用缓存避免每次递归调用都重新读取配置
      let enableWidthSetting = enableWidthSettingCache;

      if (enableWidthSetting === undefined) {
        enableWidthSetting = calculateEnableWidthSetting();
      }

      if (obj.properties) {
        this.recursiveDelete(obj.properties, enableWidthSetting);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDelete(property.properties, enableWidthSetting);
        }
        if (property.items) {
          this.recursiveDelete(property.items, enableWidthSetting);
        }
        // 限定在 ArrayTable (class: formily-element-array-table) 表格下，删除字段的 description 描述
        // 仅当 mobile_noDescription 配置的 key 包含当前 ProcessDefinitionKey 时才生效
        // 排除配置了 convert 属性的表格（表格转卡片模式）
        // if (
        //   property['x-component'] === 'ArrayTable' &&
        //   !property?.['x-component-props']?.convert &&
        //   property.items &&
        //   property.items.properties
        // ) {
        //   const noDescConfig = store.getters.getConfigItem('mobile_noDescription');
        //   const processKey = this.$props.values?.$context?.ProcessDefinitionKey;
        //   let shouldDeleteDesc = false;
        //   try {
        //     shouldDeleteDesc = noDescConfig
        //       && processKey
        //       && JSON.parse(noDescConfig).key?.includes(processKey);
        //   } catch (e) {
        //     console.warn('mobile_noDescription 配置解析失败:', e);
        //   }
        //   if (shouldDeleteDesc) {
        //     const itemsProps = property.items.properties;
        //     Object.values(itemsProps).forEach((col) => {
        //       if (col.properties) {
        //         Object.values(col.properties).forEach((field) => {
        //           if (field.description) {
        //             delete field.description;
        //           }
        //         });
        //       }
        //     });
        //   }
        // }
        if (
          [
            "DatePicker",
            "Select",
            "TimePicker",
            "Input",
            "Input.TextArea",
            "Cascader",
            "Space",
            "FormGrid",
          ].includes(property["x-component"])
        ) {
          // readPretty
          // console.log('recursiveDelete==>',property);
          if (
            property["x-component"] == "Select" &&
            property["x-pattern"] === "readPretty"
          ) {
            return;
          }
          this.removeDecorator(property);
        }
        if (
          !property.title &&
          [
            "ArrayTable",
            "ArrayCard",
            "NewArrayTable",
            "NewArrayCard",
            "MobileArrayCards",
            "ToStorageTable",
            "OutboundMeasurementTable",
            "OutgoingPieceworkTable",
            "undercarriageGoBackTable",
            "ServerEntryTable",
            "ServerOutboundTable",
            "flowTable",
            "FacilityAssetReleaseTable",
            "FacilityAssetEntryTable",
            "serverDirectAllocationTable",
            "assetLocationVerificationTable",
            "networkOutboundTable",
            "AssetesCascader",
          ].includes(property["x-component"])
        ) {
          this.removeDecorator(property);
        }
        if (
          ["Input.TextArea"].includes(property["x-component"]) &&
          property["x-pattern"] === "readPretty" &&
          !property?.title
        ) {
          property["x-component"] = "Text";
        }
        if (
          property["x-component"] === "ArrayTable.Column" &&
          Object.values(obj).length > 2
        ) {
          const decorator = property;
          // 🎨 titleColor 支持：仅当用户传入 titleColor 时生成 labelClassName 并建立 CSS 映射
          if (decorator['x-component-props'] && decorator['x-component-props'].titleColor) {
            const labelClassName = `title-color-test-${this._testColorCounter}`;
            decorator['x-component-props'].labelClassName = labelClassName;
            this._titleColorMap[labelClassName] = decorator['x-component-props'].titleColor;
            this._testColorCounter++;
          }
          // 根据配置决定是否使用动态宽度
          const getWidth = () => {
            if (enableWidthSetting && typeof window !== "undefined") {
              // 配置启用时，根据屏幕尺寸动态计算
              const screenWidth = window.innerWidth;
              if (screenWidth >= 768) return 340; // 平板端和桌面端
              return 170; // 移动端
            }
            return 170; // 配置未启用或SSR时，固定返回170
          };
          decorator["x-component-props"] = {
            ...decorator["x-component-props"],
            width: decorator["x-component-props"].width || getWidth(),
          };
        }
        if (
          property["x-component"] === "NewArrayTable.Column" &&
          Object.values(obj).length > 2
        ) {
          const decorator = property;
          // 🎨 titleColor 支持：仅当用户传入 titleColor 时生成 labelClassName 并建立 CSS 映射
          if (decorator['x-component-props'] && decorator['x-component-props'].titleColor) {
            const labelClassName = `title-color-test-${this._testColorCounter}`;
            decorator['x-component-props'].labelClassName = labelClassName;
            this._titleColorMap[labelClassName] = decorator['x-component-props'].titleColor;
            this._testColorCounter++;
          }
          // 根据配置决定是否使用动态宽度
          const getWidth = () => {
            if (enableWidthSetting && typeof window !== "undefined") {
              // 配置启用时，根据屏幕尺寸动态计算
              const screenWidth = window.innerWidth;
              if (screenWidth >= 768) return 340; // 平板端和桌面端
              return 170; // 移动端
            }
            return 170; // 配置未启用或SSR时，固定返回170
          };
          decorator["x-component-props"] = {
            ...decorator["x-component-props"],
            width: decorator["x-component-props"].width || getWidth(),
          };
        }
      });
    },
    // 移动端会把字段的 FormItem 装饰器移除（见 recursiveDelete）。
    // 被移除装饰器的字段，其“表单项容器样式”（x-decorator-props.style）会随之失效，
    // 这里在移除装饰器的同时把容器样式合并到组件样式（x-component-props.style），
    // 使 ReactiveField 将其作为组件 style 应用到输入控件根节点（如文字颜色）。
    // 注意：只处理“本会被移除装饰器”的字段，不改变其它字段的 x-decorator-props 语义。
    removeDecorator(property) {
      property["x-decorator"] = null;
      const decoratorProps = property["x-decorator-props"];
      if (decoratorProps && decoratorProps.style) {
        property["x-component-props"] = {
          ...(property["x-component-props"] || {}),
          style: {
            ...((property["x-component-props"] && property["x-component-props"].style) || {}),
            ...decoratorProps.style,
          },
        };
      }
    },
    recursiveDisable(obj) {
      if (!obj) return;
      if (obj.properties) {
        this.recursiveDisable(obj.properties);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDisable(property.properties);
        }
        if (property.items) {
          const item = property;
          if (!["Export"].includes(item["component"])) {
            item["x-pattern"] = "disabled";
            this.recursiveDisable(property.items);
          }
        }
        if (property["x-component"]) {
          const item = property;
          if (!["Export"].includes(item["component"])) {
            item["x-pattern"] = "disabled";
          }
        }
      });
    },
    // 🎨 将 titleColor 映射注入为 CSS 样式
    injectTitleColorStyles() {
      if (!this._titleColorMap || Object.keys(this._titleColorMap).length === 0) return;
      let cssText = '';
      for (const [className, color] of Object.entries(this._titleColorMap)) {
        const safeColor = color.startsWith('#') ? color : `#${color}`;
        cssText += `.${className} .cell { color: ${safeColor} !important; }\n`;
      }
      let styleEl = document.getElementById('title-color-test-styles');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'title-color-test-styles';
        document.head.appendChild(styleEl);
      }
      styleEl.textContent = cssText;
    },
    formatSchema(val) {
      try {
        this.recursiveDelete(val.schema ? val.schema : val);
        this.disabled && this.recursiveDisable(val.schema ? val.schema : val);
        val = this.convertArrayTableToArrayCards(val.schema ? val.schema : val);
        // 🎨 注入 titleColor CSS 样式
        this.injectTitleColorStyles();
        const str = JSON.stringify(val, this.formatJson).replace(
          /\/relay\/api/g,
          "/relay/ifob/api"
        );
        const res = JSON.parse(str);
        console.log(res);
        if (res && res.schema) {
          return res.schema;
        }
        return res || {};
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    formatJson(key, value) {
      if (key === "labelWidth") return undefined;
      if (key === "x-component" && value === "Input.TextArea") return "TextArea";
      if (key === "enum" && Array.isArray(value))
        return value.map((item) =>
          typeof item === "object" ? { ...item, name: item.name || item.value } : item
        );
      return value;
    },
    getValues() {
      return this.form.values;
    },
    async validate() {
      return await this.form.validate();
    },
    setValues(newVal) {
      const val = this.formatValue(newVal);
      this.form.setValues(val, "deepMerge");
    },
    reset() {
      Object.values(this.form.fields).forEach((item) => item.reset && item.reset());
    },
  },
};
</script>

<style scoped lang="less">
.formily-todo {
  // 表格转卡片（mobileCard）中扫码等组件的 description 渲染在 .van-cell__label，
  // 限制其最大宽度与标题区一致，避免超长时被右侧输入框遮挡
  /deep/ .mobileCard  .van-cell__title .van-cell__label {
      max-width: 6em !important;
    }
  /deep/ .el-pagination {
    overflow: auto;
    margin: 0 18% 0 5%;
  }
  /deep/ .ql-picker-label {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .ql-picker-options {
    z-index: 999;
  }
  /deep/ .ql-picker {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .van-cell__value.van-cell__value--alone.van-field__value {
    overflow: auto;
  }
  /deep/ .formily-vant-preview-text::after,
  /deep/ .formily-vant-preview-input::after,
  /deep/ .van-cell::after {
    display: block;
  }
  /deep/ .formily-vant-preview-input {
    position: relative;
  }
  /deep/ .formily-vant-preview-input::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  /deep/ .formily-vant-preview-text {
    position: relative;
  }
  /deep/ .formily-vant-preview-text::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  // ===== van-radio-group / van-checkbox-group：按内容自适应 + 同一行内等宽 =====
  // 核心：flex-wrap 保证按内容长度决定每行容纳数量（1/2/3 个）；
  //       flex: 1 1 <basis> + min-width 让同一行内的项目拉伸填满，视觉上等宽对齐
  /deep/ .van-cell__value .van-radio-group,
  /deep/ .van-cell__value .van-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: flex-start;
    gap: 6px 8px;
    width: 100%;
  }
  // 单个 radio / checkbox：
  //   - flex-basis: ~30%（即一行最多 3 个），当内容超长 flex-wrap 会自动减少到 2 个/1 个
  //   - flex-grow: 1 —— 同一行的项目会等比拉伸填满剩余空间，从而同行等宽
  //   - min-width 保证短内容不会被挤成过窄条
  //   - max-width: 100% 允许长内容独占一行
  /deep/ .van-cell__value .van-radio,
  /deep/ .van-cell__value .van-checkbox {
    display: inline-flex;
    align-items: center;
    flex: 1 1 calc((100% - 16px) / 3); // 一行 3 等分（减去 2 个 8px 间隙）
    min-width: 96px; // 每项最少约 6em 宽度，保证 3-4 汉字能舒展
    max-width: 100%;
    min-height: 32px;
    padding: 4px 10px;
    margin: 0 !important;
    background: #f7f8fa;
    border-radius: 6px;
    box-sizing: border-box;
    .van-radio__label,
    .van-checkbox__label {
      margin-left: 6px;
      font-size: 13px;
      line-height: 18px;
      color: #323233;
      white-space: normal;
      word-break: break-word;
      flex: 1;
      min-width: 0;
    }
    .van-radio__icon,
    .van-checkbox__icon {
      flex-shrink: 0;
    }
  }
  // 选中态高亮
  /deep/ .van-cell__value .van-radio:has(.van-radio__icon--checked),
  /deep/ .van-cell__value .van-checkbox:has(.van-checkbox__icon--checked) {
    background: #e8f3ff;
    .van-radio__label,
    .van-checkbox__label {
      color: #1989fa;
    }
  }
  /deep/ .van-field__label .van-cell {
    padding: 0;
    overflow: inherit;
    white-space: pre-line;
  }
  /deep/ .van-stepper__input {
    width: auto;
  }
  /deep/ .formily-element-array-table,
  /deep/ .formily-element-array-cards {
    width: 100% !important;
  }
  // array-cards card-wrapper 和 el-card__body 两侧空白压缩，让卡片铺满父容器宽度
  /deep/ .formily-element-array-cards .formily-element-array-cards-card-wrapper {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  /deep/ .formily-element-array-cards .el-card__body {
    padding-left: 6px !important;
    padding-right: 6px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  // ArrayCards 整体容器去掉左右外边距
  /deep/ .formily-element-array-cards {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  // ===== 空态（暂无数据）压缩 =====
  // el-empty 默认占 200+px 高度（100px 图 + 40px padding + 文字），此处统一进一步压缩
  /deep/ .formily-element-array-cards-empty-container,
  /deep/ .formily-element-array-table .el-empty,
  /deep/ .formily-element-array-cards .el-empty {
    padding: 4px 0 !important;
  }
  /deep/ .formily-element-array-cards .el-empty__image,
  /deep/ .formily-element-array-table .el-empty__image {
    width: 32px !important;
    height: 32px !important;
    margin-bottom: 2px !important;
    img,
    svg {
      width: 100% !important;
      height: 100% !important;
    }
  }
  /deep/ .formily-element-array-cards .el-empty__description,
  /deep/ .formily-element-array-table .el-empty__description {
    margin-top: 2px !important;
    p {
      font-size: 12px;
      line-height: 14px;
      color: #969799;
      margin: 0;
    }
  }
  /deep/ .formily-element-array-cards .el-empty__bottom,
  /deep/ .formily-element-array-table .el-empty__bottom {
    margin-top: 2px !important;
  }
  /deep/ .formily-element-array-cards-empty-container .el-card__body {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  // ===== 常规 ArrayCards（card.js）样式优化 =====
  // 将 mobilecard 的紧凑空态 + 标题区背景色等优化同步到常规卡片
  // 注意：这里的规则仅在新版 formilyTodoForm-new.vue 的 scoped 作用域内生效，不影响老版
  // （本段 padding/margin 相较旧值整体减少约 20%，进一步压缩卡片空白）
  /deep/ .formily-element-array-cards .formily-element-array-cards-item.el-card {
    margin-bottom: 7px; // 6 -> 7（卡片间距 +20%，稍微拉开每张卡片）
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
  }
  /deep/
    .formily-element-array-cards
    .formily-element-array-cards-item.el-card:last-child {
    margin-bottom: 0;
  }
  // 标题区：浅灰底，形成"分组标题"视觉 + 紧凑 padding（10px 14px -> 8px 11px）
  /deep/
    .formily-element-array-cards
    .formily-element-array-cards-item
    > .el-card__header {
    padding: 8px 11px !important;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
    font-weight: 600;
    color: #303133;
  }
  // 内容区：紧凑 padding（8px 12px -> 6px 10px）
  /deep/ .formily-element-array-cards .formily-element-array-cards-item > .el-card__body {
    padding: 2px 6px !important;
    background: #ffffff;
    margin-top: 0 !important;
  }
  // 空态卡片覆盖（去掉 header 底色，避免空态看起来仍像有内容）
  /deep/
    .formily-element-array-cards-empty-container
    .formily-element-array-cards-item.el-card
    > .el-card__header {
    padding: 8px 11px !important;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
  }
  // Addition 按钮紧贴卡片（margin 6px -> 5px）
  /deep/ .formily-element-array-cards .formily-element-array-base-addition.el-button {
    margin: 5px auto !important;
  }
  // 卡片内部每个 van-field 垂直 padding 同步压缩约 20%（默认 10px 16px -> 8px 12px）
  // 让卡片内字段间的纵向空白跟随卡片本身的留白一起变紧凑
  /deep/
    .formily-element-array-cards
    .formily-element-array-cards-item
    > .el-card__body
    .van-cell,
  /deep/
    .formily-element-array-cards
    .formily-element-array-cards-item
    > .el-card__body
    .van-field {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  // ===== ArrayCards / ArrayTable 作为容器字段时，label 独占顶部一行 =====
  // 避免左侧 label 固定 6em、右侧 value 区域留下大块空白
  /deep/ .van-cell:has(.formily-element-array-cards),
  /deep/ .van-cell:has(.formily-element-array-table),
  /deep/ .van-field:has(.formily-element-array-cards),
  /deep/ .van-field:has(.formily-element-array-table) {
    flex-direction: column;
    align-items: stretch;
    padding-left: 8px;
    padding-right: 8px;
    > .van-cell__title,
    > .van-field__label {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin-right: 0;
      margin-bottom: 4px;
    }
    > .van-cell__value,
    > .van-field__value {
      width: 100%;
      max-width: 100%;
    }
  }
  // Radio/Checkbox 在表格中：保持水平布局，不被 flex-direction:column 影响
  /deep/ .van-field .formily-radio-field,
  /deep/ .van-field .formily-checkbox-field {
    width: 100%;
    display: inline-block;
  }
  // 确保 Radio/Checkbox 的 van-cell__value 正确撑开
  /deep/ .van-cell__value .van-radio-group,
  /deep/ .van-cell__value .van-checkbox-group {
    width: 100%;
  }
  // 纯展示态 label：按内容自适应（最小 6em，最大 12em），避免长 label 换行 + 短值右侧留白
  /deep/ .formily-vant-preview-input-title {
    color: #646566;
    font-size: 14px;
    width: auto;
    min-width: 6em;
    max-width: 10em;
    flex-shrink: 0;
    margin-right: 12px;
    // 长 label 单行显示，超出省略（鼠标/点击可看完整 title 属性）
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  /deep/ .van-field__label .van-cell::after {
    border: none;
  }
  /deep/ .van-field--disabled {
    background: #f7f8fa;
    transition: background 0.2s ease-out;
  }
  // 设计器“容器样式”字体颜色：vant 输入元素自身有显式 color，
  // 在容器设置了颜色（style 含 color）时让输入内容继承外层颜色
  /deep/ .van-field[style*="color:"] .van-field__control:not(:disabled) {
    color: inherit;
  }

  /deep/ .van-cell__value.van-field__value:has(.formily-element-array-table) {
    overflow: inherit;
  }

  &.enable-width-setting {
    // ===== Radio/Checkbox 的 description 独占第二行 =====
    // /deep/ .formily-element-array-table {
    /deep/ .formily-element-array-table.formily-vant-field-radio .van-field__body {
      flex-wrap: wrap;
    }
    // 避免单选框的描述超长时，被组件遮盖
    /deep/ .mobileCard .formily-vant-field-radio .van-cell__label {
      width: 62%;
    }
    /deep/ .formily-vant-field-radio .van-cell__label {
      width: 62%;
    }

    /deep/ .formily-vant-field-radio .formily-vant-field-desc-radio {
      flex-basis: 100%;
      width: 100%;
      max-width: 100%;
      margin-top: 4px;
      font-size: 12px;
      color: #969799;
      line-height: 1.5;
      text-align: left;
    }
    /deep/ .formily-element-array-table .formily-vant-field-radio.van-field {
      display: flex;
      flex-direction: column;
    }
    /deep/ .formily-element-array-table .formily-vant-field-radio .van-field__body {
      flex-direction: column;
    }

    // }

    // ===== ArrayTable / ArrayCards 内部输入框：title在第一行，description在第二行 =====
    /deep/ .formily-element-array-table,
    /deep/ .formily-element-array-cards {
      .van-field {
        flex-wrap: wrap;
        align-items: center;

        // title 和输入框在同一行（默认 order: 0）
        > .van-cell__title.van-field__label {
          flex: none;
          width: 6em;
          min-width: 6em;
          max-width: 6em;
        }

        // 输入框值区域在第一行
        > .van-cell__value.van-field__value {
          flex: 1;
          width: auto;
          min-width: 0;
        }

        // 图片上传和语音输入图标在第一行
        > .image-upload-input,
        > .voice-input-icon {
          flex-shrink: 0;
        }

        // description 独占第二行，自动换行
        > .formily-vant-field-desc {
          order: 3;
          flex-basis: 100%;
          width: 100%;
          max-width: 100%;
          font-size: 12px;
          color: #969799;
          line-height: 16px;
          margin-top: 2px;
          // overflow-wrap: break-word;
          // word-break: break-all;
          white-space: pre-wrap;
        }
      }
    }

    /* ===== mobileCard（表格转卡片）内部输入框：title在第一行，description在第二行 ===== */
    /deep/ .mobileCard {
      .van-field {
        flex-wrap: wrap;
        align-items: center;

        // title 和输入框在同一行
        > .van-cell__title.van-field__label {
          flex: none;
          width: 6em;
          min-width: 6em;
          max-width: 6em;
        }

        // 输入框值区域在第一行
        > .van-cell__value.van-field__value {
          flex: 1;
          width: auto;
          min-width: 0;
        }

        // 图片上传和语音输入图标在第一行
        > .image-upload-input,
        > .voice-input-icon {
          flex-shrink: 0;
        }

        // description 独占第二行，自动换行
        > .formily-vant-field-desc {
          order: 3;
          flex-basis: 100%;
          width: 100%;
          max-width: 100%;
          font-size: 12px;
          color: #969799;
          line-height: 16px;
          margin-top: 2px;
          // overflow-wrap: break-word;
          // word-break: break-all;
          white-space: pre-wrap;
        }
      }
    }
  }

  /deep/ .van-field {
    transition: background 0.2s ease-out;
  }
  /* 针对父级包含 mobileCard 类的元素特殊处理 */
  /* 当 mobileCard 只有一个子元素时 */
  /deep/ .mobileCard:has(> :only-child) .el-card__header {
    padding: 6px 10px;
    background: linear-gradient(90deg, #ecf5ff 0%, #f5faff 100%);
    border-left: 3px solid #1989fa;
    border-bottom: 1px solid #e4ecf7;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1d2129;
  }

  /* 当 mobileCard 有多个子元素时 */
  /deep/ .mobileCard:not(:has(> :only-child)) .el-card__header {
    padding: 6px 12px;
    background: linear-gradient(90deg, #ecf5ff 0%, #f5faff 100%);
    border-left: 3px solid #1989fa;
    border-bottom: 1px solid #e4ecf7;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1d2129;
  }

  /* 默认样式（兼容不支持 :has() 的浏览器） */
  /deep/ .mobileCard .el-card__header {
    padding: 6px 12px;
    background: linear-gradient(90deg, #ecf5ff 0%, #f5faff 100%);
    border-left: 3px solid #1989fa;
    border-bottom: 1px solid #e4ecf7;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1d2129;
    // header 内的 span / row / col 全部继承 14px，避免出现大标题
    .el-row,
    .el-row > .el-col,
    span {
      font-size: 14px;
      line-height: 20px;
    }
    .el-row,
    .el-row > .el-col {
      align-items: center;
    }
  }

  /* ========= 横向轮播版（HorizontalVersion）header 紧凑化 ========= */
  /* 更高特异性 + !important，覆盖 formily-element-array-cards 通用规则 */
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header {
    padding: 2px 10px !important;
    min-height: 0 !important;
    background: linear-gradient(90deg, #ecf5ff 0%, #f5faff 100%) !important;
    border-left: 3px solid #1989fa !important;
    border-bottom: 1px solid #e4ecf7 !important;
    font-weight: 500;
    font-size: 13px !important;
    line-height: 13px !important;
    color: #1d2129;
  }
  /* header 内的 Row / Col / span 强制小字号 + 紧凑对齐 */
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    .el-row {
    align-items: center;
    min-height: 0 !important;
    line-height: 13px !important;
  }
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    .el-row
    > .el-col,
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    span {
    font-size: 13px !important;
    line-height: 13px !important;
  }
  /* header 内 Index 组件（#N.）与 Remove 图标也压一下，避免把行撑高 */
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    .formily-element-array-base-index,
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    .formily-element-array-base-remove,
  /deep/
    .formily-element-array-cards-carousel-container.mobileCard
    .formily-element-array-cards-item.el-card
    > .el-card__header
    i {
    font-size: 13px !important;
    line-height: 13px !important;
    vertical-align: middle;
  }
  /* ArrayCards 空态卡片的头部样式保持一致 */
  /deep/ .formily-element-array-cards-empty-container .el-card__header {
    padding: 8px 14px;
    background: linear-gradient(90deg, #ecf5ff 0%, #f5faff 100%);
    border-left: 3px solid #1989fa;
    border-bottom: 1px solid #e4ecf7;
    font-weight: 500;
    color: #1d2129;
  }
  /deep/ .mobileCard .el-card__body {
    padding-top: 0;
    padding-bottom: 0;
  }
  /deep/ .mobileCard .van-field {
    transition: background 0.2s ease-out;
    flex-wrap: wrap !important;
    align-content: flex-start;
    align-items: flex-start;
  }
  /deep/ .mobileCard .el-row--flex.is-justify-space-between {
    align-items: center;
  }

  // ===== mobileCard 内部 label：与卡片外只读态保持一致的自适应策略 =====
  // 规则：最小 6em 保证对齐，最多 12em 防止挤占 value；超出单行省略，永不换行。
  // 说明：覆盖原先 "width: 100% 整行" 的写法，改为 label 与 value 并排；
  // 当 value 为 Radio/Checkbox 组等宽组件时，van-field 自身的 flex-wrap 仍会让
  // value 自动换到下一行，不影响复杂组件展示。
  /deep/ .mobileCard .van-field__label,
  /deep/ .mobileCard .van-cell__title {
    // width: auto !important;
    min-width: 6em !important;
    max-width: 10em !important;
    flex: 0 0 auto !important;
    // margin-right: 12px;
    // white-space: wrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  /deep/ .mobileCard .van-cell__value {
    // 让 value 填满剩余空间；若与 label 总宽超行，flex-wrap 会自动换行
    flex: 1 1 0 !important;
    width: auto;
    min-width: 0;
    max-width: 100%;
  }

  /deep/ .mobileCard .van-field__value {
    flex: 1 1 0 !important;
    width: auto;
    min-width: 0;
    max-width: 100%;
  }

  /deep/ .mobileCard .van-cell {
    flex-wrap: wrap;
  }

  /deep/ .mobileCard .van-cell > * {
    // flex: 1 1 auto;
    box-sizing: border-box;
  }
  // 仅当 field 显式声明 flex-wrap（动态长内容/复杂组件场景）时，才恢复原先 100% 整行布局
  /deep/ .mobileCard .van-field[style*="flex-wrap"] > *,
  /deep/ .mobileCard .van-field.flex-wrap > * {
    flex: 1 1 100% !important;
    width: 100% !important;
    margin-bottom: 8px;
  }
  /deep/ .mobileCard .van-stepper {
    display: flex;
  }
  /deep/ .mobileCardHorizontalVersion .van-stepper {
    display: flex;
  }
  /deep/ .mobileCardHorizontalVersion .van-stepper__input {
    width: 60%;
  }

  /* 如果需要针对包含 mobileCard 的 van-field 本身也设置样式 */
  /deep/ .van-field:has(.mobileCard) {
    flex-direction: column;
  }

  // ===== mobileCard 内部「纯展示态」字段：与编辑态 label 保持一致 =====
  // formily-vant-preview-input 是纯展示/只读态 PreviewText 的容器（flex 布局）。
  // 规则：label 最小 6em、最多 12em；超出单行省略，永不换行；value 填满剩余空间。
  /deep/ .mobileCard .formily-vant-preview-input {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
  /deep/ .mobileCard .formily-vant-preview-input-title {
    width: auto !important;
    min-width: 6em !important;
    max-width: 10em !important;
    flex: 0 0 auto !important;
    margin-right: 12px;
    margin-bottom: 0;
    white-space: wrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  // 仅针对 Select (Picker) 组件的预览文本设置 padding 为 0
  /deep/ .van-field__control--custom .picker-preview-text.formily-vant-preview-text {
    padding: 0;
  }
  /deep/.formily-element-array-cards-empty-container.formily-element-array-cards.formily-element-array-cards-horizontal.mobileCard {
    min-height: auto !important;
  }

  // ===== Switch 组件减少留白 =====
  /deep/ .van-field__control--custom .van-switch {
    margin: 0; // 取消 margin: 0 auto 的居中留白
  }
  /deep/ .van-field:has(.van-switch) {
    padding: 6px 16px;
    min-height: auto;
    // 将 label slot 中 van-cell 的 description 改为横向展示
    .van-field__label {
      .van-cell {
        &[disabled] {
          background-color: #f7f8fa;
        }
        display: flex;
        flex-direction: row;
        align-items: baseline;
        padding: 0;
        gap: 6px;
        &::after {
          display: none; // 去掉 cell 的底部边框
        }
        .van-cell__title {
          flex: none;
          font-size: 14px;
        }
        .van-cell__label {
          margin-top: 0;
          font-size: 11px;
          color: #969799;
          max-width: 80vw;
          // white-space: wrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }
      }
    }
  }

  // ===== Location 打卡组件减少留白 =====
  /deep/ .van-field__control--custom .w {
    padding: 0;
    width: 100%;
    .flex-h-between {
      padding: 4px 0;
      justify-content: center;
    }
    .flex {
      justify-content: center;
    }
    .btn {
      height: 36px;
      padding: 0 12px;
      font-size: 13px;
    }
    .desc {
      height: 36px;
    }
  }
  /deep/ .van-field:has(.w) {
    padding: 6px 16px;
  }

  // ===== 打卡按钮配色柔化 =====
  // Location.vue 里通过 prop color="linear-gradient(to right, #ff9034, #ee0a24)"
  // 直接把红橙渐变写成了内联 style，视觉过于鲜艳刺眼。
  // 这里用 !important 覆盖内联样式，换成与页面腾讯蓝主题一致的柔和蓝色渐变，
  // 采用 135deg 斜向 + 3 色站点（浅蓝 → 主蓝 → 深蓝），让渐变更有层次。
  // /deep/ .van-field__control--custom .w .btn.van-button {
  //   background: linear-gradient(
  //     135deg,
  //     #a6d4ff 0%,
  //     #1989fa 55%,
  //     #0862c7 100%
  //   ) !important;
  //   border: none !important;
  //   color: #ffffff !important;
  //   box-shadow: 0 1px 3px rgba(8, 98, 199, 0.2);
  // }
  // /deep/ .van-field__control--custom .w .btn.van-button .van-button__text,
  // /deep/ .van-field__control--custom .w .btn.van-button .el-icon {
  //   color: #ffffff !important;
  // }
  // // 按下态：整体加深，保持同样的渐变方向和层次
  // /deep/ .van-field__control--custom .w .btn.van-button:active {
  //   background: linear-gradient(
  //     135deg,
  //     #85c1fb 0%,
  //     #167ae0 55%,
  //     #054f9f 100%
  //   ) !important;
  // }

  // ===== 统一表单 label 样式（van-cell 类组件） =====
  /deep/ .formily-vant-preview-input {
    font-size: 14px;
    line-height: 24px;
    color: #323233;
    padding: 10px 16px;
    align-items: center;
  }

  /deep/ .formily-vant-preview-text {
    padding: 10px 16px;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
  }

  /deep/ .van-field > .van-field__label {
    color: #646566;
    font-size: 14px;
    flex: none;
    width: 6em;
    min-width: 6em;
    max-width: 6em;
  }

  // ===== 腾讯蓝色主题覆盖（替换 vant 绿色主题） =====
  // 覆盖 vant CSS 变量
  --van-blue: #1989fa;
  --van-green: #1989fa;
  --van-button-primary-background-color: #1989fa;
  --van-button-primary-border-color: #1989fa;
  --van-switch-on-background-color: #1989fa;
  --van-checkbox-checked-icon-color: #1989fa;
  --van-radio-checked-icon-color: #1989fa;
  --van-stepper-button-round-theme-color: #1989fa;
  --van-tabs-bottom-bar-color: #1989fa;
  --van-slider-active-background-color: #1989fa;
  --van-progress-color: #1989fa;
  --van-loading-spinner-color: #1989fa;
  --van-step-active-color: #1989fa;
  --van-step-process-text-color: #1989fa;
  --van-step-finish-line-color: #1989fa;
  --van-step-finish-text-color: #1989fa;

  // van-button 主题色覆盖
  /deep/ .van-button--primary {
    background-color: #1989fa;
    border-color: #1989fa;
  }
  /deep/ .van-button--info {
    background-color: #1989fa;
    border-color: #1989fa;
  }
  /deep/ .van-button--default {
    color: #1989fa;
    border-color: #1989fa;
  }

  // van-switch 选中状态
  /deep/ .van-switch--on {
    background-color: #1989fa;
  }

  // van-checkbox / van-radio 选中状态
  /deep/ .van-checkbox__icon--checked .van-icon {
    background-color: #1989fa;
    border-color: #1989fa;
  }
  /deep/ .van-radio__icon--checked .van-icon {
    background-color: #1989fa;
    border-color: #1989fa;
  }

  // van-stepper 按钮
  /deep/ .van-stepper__minus,
  /deep/ .van-stepper__plus {
    background-color: #1989fa;
    color: #fff;
  }

  // van-tabs 下划线
  /deep/ .van-tabs__line {
    background-color: #1989fa;
  }

  // ===== FormTab 同步 PC 端默认形式，并按 type 区分 line/card =====
  /deep/ .formily-element-form-tab {
    background: #ffffff;

    .van-tabs__nav {
      background: #ffffff;
    }

    // 通用 tab 文字样式：默认样式不覆盖 formTab.js 的 titleFontColor/titleFontBold 内联配置
    .van-tab {
      color: var(--form-tab-title-font-color, #64748b) !important;
      font-size: 14px;
      font-weight: 500;
      background: #ffffff !important;
      transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);

      .van-tab__text > div {
        color: var(--form-tab-title-font-color, #64748b) !important;
        font-weight: 500;
      }

      &:hover {
        color: #4096ff !important;
      }

      &:hover .van-tab__text > div {
        color: #4096ff !important;
      }

      &.van-tab--active,
      &.van-tab--active .van-tab__text {
        color: #1677ff !important;
        font-weight: 600 !important;
      }

      &.van-tab--active .van-tab__text > div {
        color: #1677ff !important;
        font-weight: 600;
      }

      &.van-tab--disabled {
        color: #c0c4cc !important;
      }

      &.van-tab--disabled .van-tab__text > div {
        color: #c0c4cc;
      }
    }
  }

  /deep/ .formily-element-form-tab--line {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: 1px solid #e4e7ed;
    }

    .van-tabs__line {
      display: block;
      height: 3px;
      background-color: #1677ff;
      border-radius: 2px;
    }
  }

  /deep/ .formily-element-form-tab--card {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: var(--form-tab-card-border-width, 1px) solid
        var(--form-tab-card-border-color, #e4e7ed);
    }

    .van-tabs__line {
      display: none;
    }

    .van-tabs__nav--card {
      height: 44px;
      margin: 0;
      overflow: hidden;
      background: #ffffff;
      border: var(--form-tab-card-border-width, 1px) solid
        var(--form-tab-card-border-color, #e4e7ed);
      border-bottom: none;
      border-radius: 4px 4px 0 0;

      .van-tab {
        color: var(--form-tab-title-font-color, #1e293b) !important;
        line-height: 42px;
        background: #ffffff !important;
        border-right: var(--form-tab-card-border-width, 1px) solid
          var(--form-tab-card-border-color, #e4e7ed);

        .van-tab__text > div {
          color: var(--form-tab-title-font-color, #1e293b) !important;
        }

        &:last-child {
          border-right: none;
        }

        &:hover {
          color: #4096ff !important;
        }

        &:hover .van-tab__text > div {
          color: #4096ff !important;
        }

&.van-tab--active {
          color: #1677ff !important;
          background: var(--form-tab-card-active-background, #ffffff) !important;
        }

        &.van-tab--active .van-tab__text > div {
          color: #1677ff !important;
        }
      }
    }
  }

  // van-loading
  /deep/ .van-loading__spinner {
    color: #1989fa;
  }

  // van-step 步骤条主题色覆盖
  /deep/ .van-step--finish {
    .van-step__circle,
    .van-step__icon {
      color: #1989fa;
    }
    .van-step__circle {
      background-color: #1989fa;
      border-color: #1989fa;
    }
    .van-step__line {
      background-color: #1989fa;
    }
    .van-step__title {
      color: #1989fa;
    }
  }
  /deep/ .van-step--process {
    .van-step__icon {
      color: #1989fa;
    }
    .van-step__circle {
      background-color: #1989fa;
      border-color: #1989fa;
    }
    .van-step__title {
      color: #1989fa;
    }
  }
  /deep/ .van-steps--horizontal .van-step--finish .van-step__circle-container::after {
    background-color: #1989fa;
  }
  /deep/ .van-steps--vertical .van-step--finish .van-step__line {
    background-color: #1989fa;
  }
  /deep/ .van-step__icon--active,
  /deep/ .van-step__icon--finish {
    color: #1989fa;
  }

  // element-ui 按钮主题色覆盖
  /deep/ .el-button--primary {
    background-color: #1989fa;
    border-color: #1989fa;
    &:hover,
    &:focus {
      background-color: #66b1ff;
      border-color: #66b1ff;
    }
  }
  /deep/ .el-button--text {
    color: #1989fa;
  }

  // ===== 所有 button 圆角、去 border、默认 margin、缩小尺寸 =====
  // 包含多个按钮的容器自动并排展示（排除 stepper 等组件）
  /deep/ .van-field__control--custom:not(:has(.van-stepper)) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0;
  }
  // stepper 组件宽度限制，避免输入区域撑满
  /deep/ .van-stepper {
    display: inline-flex;
    .van-stepper__input {
      width: 60px;
    }
  }
  /deep/ .van-button {
    border-radius: 8px;
    border: none;
    // margin: 4px;
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
    // line-height: 32px;
  }
  // default 类型按钮（如表格"添加"按钮）保留边框
  /deep/ .van-button--default {
    border: 1px solid #1989fa;
  }
  /deep/ .van-button--large {
    height: 32px;
    width: auto;
  }
  /deep/ .van-button--round {
    border-radius: 999px;
  }
  /deep/ .van-button--square {
    border-radius: 0;
  }
  /deep/ .el-button {
    border-radius: 8px;
    border: none;
    margin: 4px;
  }
  // default 类型按钮保留边框
  /deep/ .el-button--default {
    border: 1px solid #dcdfe6;
    &:hover,
    &:focus {
      border-color: #1989fa;
    }
  }
  // ArrayCards Addition 按钮（表格"添加"按钮）保留边框
  /deep/ .formily-element-array-base-addition.el-button {
    border: 1px solid #1989fa;
    color: #1989fa;
    background: transparent;
    margin: 4px 4px 8px 4px !important; // 减少下边距
    &:hover,
    &:focus {
      background: #ecf5ff;
      border-color: #66b1ff;
      color: #66b1ff;
    }
  }
  // Addition 按钮容器的上边距（与卡片间距同步 +20%：6px -> 7px）
  /deep/ .formily-element-array-cards > div > div:last-child {
    margin-top: 7px !important;
  }
  /deep/ .el-button--mini {
    border-radius: 6px;
  }
}
</style>
<style lang="less">
.van-picker-column__item--selected {
  /* 重写选中后的效果 */
  .van-ellipsis {
    text-overflow: unset;
    overflow: visible;
    white-space: unset;
  }
}
.el-message-box {
  width: 300px !important;
}
.el-message {
  min-width: 300px !important;
}

// ===== 统一待办详情页中 van-cell 类组件的 label 样式 =====
// 仅作用于 .formily-todo 及其同级的 van-cell，不影响 van-collapse-item 内部
.formily-todo {
  // formily preview-input 标题统一
  .formily-vant-preview-input {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .formily-vant-preview-input-title {
    color: #646566;
    font-size: 14px;
    width: auto;
    min-width: 6em;
    max-width: 10em;
    flex-shrink: 0;
    margin-right: 12px;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  // formily-element-form-grid 内的 title 不继承上面的宽度限制
  .formily-element-form-grid .formily-vant-preview-input-title {
    width: unset;
    min-width: unset;
    max-width: unset;
    flex-shrink: unset;
    margin-right: unset;
  }
  .formily-vant-preview-text {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  // formily 中 van-field label 统一
  .van-field > .van-field__label {
    color: #646566;
    font-size: 14px;
    flex: none;
    width: 6em;
    min-width: 6em;
    max-width: 6em;
  }
  .van-field > .van-field__value {
    color: #323233;
    font-size: 14px;
  }
}

// 统一 todo-wrapper 中直接 van-cell 的 label 样式（原生 van-cell，非 collapse 内部）
.todo-wrapper > div > div > .van-cell,
.todo-wrapper > div > .van-form > .van-cell {
  font-size: 14px;
  > .van-cell__title {
    color: #646566;
    font-size: 14px;
    flex: none;
    width: 6em;
    min-width: 6em;
    max-width: 6em;
  }
  > .van-cell__value {
    color: #323233;
    font-size: 14px;
  }
}
</style>
